import React from 'react';
import { Link } from 'react-router-dom';
import { Flame } from 'lucide-react';

export default function Logo({ compact = false }) {
  return (
    <Link to="/" className="flex items-center gap-2 group">
      <span className="relative flex items-center justify-center">
        <span className="absolute inset-0 rounded-full bg-orange-500/20 blur-md" />
        <Flame className="relative h-7 w-7 text-orange-500 animate-flame" strokeWidth={2.4} />
      </span>
      <span className={`font-heading font-extrabold tracking-wide ${compact ? 'text-xl' : 'text-2xl'} leading-none`}>
        <span className="text-white">24BET</span>
        <span className="orange-text-gradient">BOX</span>
      </span>
    </Link>
  );
}
